module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/hokkori_kazoku_dancho-cad67a2e14f177507deef26dba3f0955.png";